/**
 * We cannot put a clients funding type or support type directly into Segment as it expose private medical PII
 * about them in overseas servers. What we can do is obscure it so no one can view it directly.
 *
 * See: https://docs.google.com/spreadsheets/d/1-ZyNuIawMOiWaETXOG8jxMMx9uygshv1mEbZgrPmHVk/edit#gid=1731557620
 */

/**
 * Type of funding for a client
 */
export const segmentObfuscatedTypeOfFunding = new Map<string, string>([
  ['ndis_funding', 'A'],
  ['home_care_package', 'B'],
  ['waiting_for_funding', 'C'],
  ['pay_privately', 'D'],
  ['other', 'E'],
]);

/**
 * Funding type codes for a client.
 */
export const segmentObfuscatedFundingCodes = new Map<string, string>([
  ['Self Managed NDIS Funding', 'A'],
  ['ndis_self_managed', 'A'],
  ['Plan Managed NDIS Funding', 'B'],
  ['ndis_plan_managed', 'B'],
  ['NDIA Managed NDIS Funding', 'C'],
  ['ndis_agency_managed', 'C'],
  ['Home Care Package', 'D'],
  ['home_care_package', 'D'],
  ['Privately Paying', 'E'],
  ['privately_paying', 'E'],
  ['Waiting For Funding', 'F'],
  ['Other', 'G'],
  ['other', 'G'],
]);

/**
 * Support type codes for a client.
 */
// TODO(ES-37908): Remove, as question is removed from signup flow
export const segmentObfuscatedSupportTypeCodes = new Map<string, string>([
  ['Disability Support', 'A'],
  ['Aged Care', 'B'],
  ['Mental Health', 'C'],
  ['Post-Surgery', 'D'],
  ['Other', 'E'],
]);
